import * as React from 'react';
import { useCallback } from 'react';
import { notifyViewStartLoading, notifyViewFinishedLoading } from '@wix/business-manager-api';
import { COMPONENT_NAME, ROUTE } from './config';
import AppContainer from '../common/AppContainer';

export default function BizMgrClient(props) {
  const { accountLanguage, debug, config, metaSiteId } = props;
  const basename = `${props.routeBaseName}${metaSiteId}/${ROUTE}`;
  return (
    <AppContainer
      basename={basename}
      experimentScope="business-manager"
      notifyViewStartLoading={useCallback(() => notifyViewStartLoading(COMPONENT_NAME), [])}
      notifyViewFinishedLoading={useCallback(() => notifyViewFinishedLoading(COMPONENT_NAME), [])}
      locale={accountLanguage}
      debug={debug}
      config={config}
      msid={metaSiteId}
      />
  );
}
